import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { useDescribeHooks } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { operationHelpers } from "../../../../operations"
import { Product, useProductLoaders } from "../../../../products"
import { ManualCreditNoteData, useAdjustmentNoteService } from "../../../../administration"
import { SaleOperation } from "../../../state/types"
import { ManualCreditNoteForm } from "./manualCreditNoteForm"

export const ManualCreditNoteFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const table = tableName!
    const operation = dataType! as SaleOperation

    const [ready, setReady] = useState(false)
    const [data, setData] = useState<ManualCreditNoteData>()
    const [products, setProducts] = useState<Product[]>([])

    const { describeCode } = operationHelpers
    const { describe } = useDescribeHooks()

    const { loadManualCreditNoteData } = useAdjustmentNoteService()
    const productLoaders = useProductLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const isSale = useMemo(() => table === TableName.SALE_ORDERS, [])

    // Invoices and notes are read from the db: they decide what is invoiced and the discounts the items already got
    const load = async () => {
        const [loadedData, loadedProducts] = await Promise.all([
            loadManualCreditNoteData(table, operation),
            productLoaders().loadProducts(operation.items.map(item => item.productId))
        ])
        setData(loadedData)
        setProducts(loadedProducts)
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = `Nota de Crédito de ${describe(table, operation)}`
    const crumbs = useGetCrumbs(
        isSale ? 'Ventas' : 'Acopios',
        isSale ? RoutePath.SALES : RoutePath.HOARDS,
        describeCode(operation),
        operation.id,
        'Nota de Crédito'
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <ManualCreditNoteForm
                table={table}
                operation={operation}
                data={data!}
                products={products}
            />
        </PanelLoader>
    )
}
